module.exports = __webpack_public_path__ + "img/gn.7fd93e63.svg";